import React, { Fragment } from "react";
import { Switch, Route } from "react-router";
import customRoutes from "./customRoutes";
import ErrorBoundary from "theme/components/helpers/ErrorBoundary";

const wrapWithErrorComponent = (routeList, ErrorComponent) => {
  return (
    <ErrorBoundary>
      {({ hasError, error }) => {
        if (hasError) {
          return <ErrorComponent error={error} statusCode={500} />;
        } else {
          return routeList;
        }
      }}
    </ErrorBoundary>
  );
};

const renderLayout = (path, layout, routes, error) => {
  return (
    <Route
      key={path || "404-route"}
      path={path}
      render={(routeProps) => {
        if (layout) {
          const routeList = renderRouteList(
            routes,
            error,
            path ? [] : customRoutes()
          );

          return React.createElement(layout, {
            ...routeProps,
            basePath: removeTrailingSlash(routeProps.match.path),
            children: error
              ? wrapWithErrorComponent(routeList, error)
              : routeList,
          });
        } else {
          return React.createElement(Fragment, {
            children: renderRouteList(routes, error),
          });
        }
      }}
    />
  );
};

const renderRoute = (path, exact, component, props) => {
  return (
    <Route
      key={path || "404-route"}
      exact={exact}
      path={path ? path : undefined}
      render={(routeProps) => {
        if (
          component.cacheControlDefinition &&
          routeProps.staticContext?.cacheControlDefinitions
        ) {
          routeProps.staticContext.cacheControlDefinitions.push(
            component.cacheControlDefinition
          );
        }
        return React.createElement(component, {
          basePath: removeTrailingSlash(routeProps.match.path),
          ...props,
          ...routeProps,
        });
      }}
    />
  );
};

const render404Route = (error) => {
  return renderRoute(null, false, error, {
    statusCode: 404,
  });
};

const removeTrailingSlash = (path) => path.replace(/\/$/, "");
const renderRouteList = (routes, error, customRoutes = []) => {
  return (
    <Switch>
      {[]
        .concat(customRoutes)
        .concat(
          routes.map((route) => {
            if (route.routes) {
              return renderLayout(
                route.path,
                route.layout,
                route.routes,
                route.error
              );
            } else {
              return renderRoute(route.path, route.exact, route.component);
            }
          })
        )
        .concat(error ? [render404Route(error)] : [])}
    </Switch>
  );
};

export default (routes) => renderRouteList(routes);
